import gql from 'graphql-tag';

const CONTRACT_DATA_FRAGMENT = gql`
  fragment contractData on ContractVersion {
    contractType
    displayName
    fileUrl
    id
    scrollRequired
  }
`;

export const GET_CONTRACT_VERSION = gql`
  query GetContractVersion($id: Int!) {
    contractVersion(id: $id) {
      ...contractData
    }
  }
  ${CONTRACT_DATA_FRAGMENT}
`;

export const GET_STATE_CONTRACTS = gql`
  query GetStateContracts($stateId: Int!, $tags: [ContractTag!]!) {
    stateContractVersions(stateId: $stateId) {
      ...contractData
    }
    taggedContractVersions(stateId: $stateId, tag: $tags) {
      ...contractData
      tag
    }
  }
  ${CONTRACT_DATA_FRAGMENT}
`;

export const getContractVersionMock = ({ scrollRequired }) => ({
  contractVersion: {
    __typename: 'ContractVersion',
    contractType: 'vnm',
    displayName: 'Community Solar Agency Agreement',
    fileUrl: 'http://agency.contract.pdf',
    id: 1000,
    scrollRequired,
  },
});

export const getStateContractsMock = ({ scrollRequired }) => ({
  stateContractVersions: [
    {
      __typename: 'ContractVersion',
      contractType: 'vnm',
      displayName: 'Community Solar Agency Agreement',
      fileUrl: 'http://agency.contract.pdf',
      id: 1000,
      scrollRequired,
    },
    {
      __typename: 'ContractVersion',
      contractType: 'vnm',
      displayName: 'Community Solar Subscriber Agreement',
      fileUrl: 'http://agency.contract.pdf',
      id: 1001,
      scrollRequired: false,
    },
  ],
  taggedContractVersions: [],
});

export const getTaggedStateContractsMock = ({ scrollRequired }) => ({
  ...getStateContractsMock({ scrollRequired }),
  taggedContractVersions: [
    {
      __typename: 'ContractVersion',
      contractType: 'vnm',
      displayName: 'SMB Community Solar Agency Agreement',
      fileUrl: 'http://agency.contract.pdf',
      id: 1002,
      scrollRequired,
      tag: 'smb_10_off',
    },
    {
      __typename: 'ContractVersion',
      contractType: 'vnm',
      displayName: 'SMB Community Solar Subscriber Agreement',
      fileUrl: 'http://agency.contract.pdf',
      id: 1003,
      scrollRequired: false,
      tag: 'smb_10_off',
    },
  ],
});

export const getVnmSolarProjectContractsMock = {
  utilityAccount: {
    vnmSubscription: {
      id: 1,
      vnmSolarProject: {
        id: 10,
        vnmSolarProjectContracts: [
          {
            contractVersion: {
              __typename: 'ContractVersion',
              contractType: 'vnm',
              displayName: 'Community Solar Agency Agreement',
              fileUrl: 'http://agency.contract.pdf',
              id: 1000,
              scrollRequired: false,
            },
            id: 100,
          },
          {
            contractVersion: {
              __typename: 'ContractVersion',
              contractType: 'direct',
              displayName: 'Community Solar Subscriber Agreement',
              fileUrl: 'http://subscriber.contract.pdf',
              id: 1001,
              scrollRequired: false,
            },
            id: 101,
          },
          {
            contractVersion: {
              __typename: 'ContractVersion',
              contractType: 'vnm',
              displayName: 'Community Solar Contract Disclosure Form',
              fileUrl: 'http://disclosure.contract.pdf',
              id: 1002,
              scrollRequired: true,
            },
            id: 102,
          },
        ],
      },
    },
    id: 10,
  },
};

export const subscriptionMock =
  getVnmSolarProjectContractsMock.utilityAccount.vnmSubscription;
export const getVnmSolarProjectContractsMockNonScrollable = {
  utilityAccount: {
    vnmSubscription: {
      id: subscriptionMock.id,
      vnmSolarProject: {
        id: subscriptionMock.vnmSolarProject.id,
        vnmSolarProjectContracts:
          subscriptionMock.vnmSolarProject.vnmSolarProjectContracts.filter(
            contract => !contract.contractVersion.scrollRequired
          ),
      },
    },
    id: 10,
  },
};

export const CREATE_CONTRACT_AGREEMENTS = gql`
  mutation CreateContractAgreements($input: [CreateContractAgreementInput!]!) {
    createContractAgreements(input: $input) {
      success
    }
  }
`;

export const createContractAgreementsMock = {
  createContractAgreements: {
    success: true,
  },
};

export const createContractAgreementsMutationMocks = (
  contractVersionIds: number[]
) => {
  return [
    {
      data: createContractAgreementsMock,
      query: CREATE_CONTRACT_AGREEMENTS,
      variables: {
        input: contractVersionIds.map((contractVersionId: number) => ({
          contractVersionId,
          userAgent: global.navigator.userAgent,
          userId: 10,
        })),
      },
    },
  ];
};
